<p [ngClass]="cModel.headerClassName">{{cModel.chartHeader}}</p>
<p-chart
  [type]="cModel.chartType"
  [ngClass]="cModel.canvasClassName" 
  [width]="cModel.chartWidth" 
  [height]="cModel.chartHeight" 
  [responsive]="cModel.isResponsive" 
  [data]="data" 
  [options]="options" (onDataSelect)="selectData($event)" ></p-chart>
